import React from 'react'
import Card from '../components/Card'
import Review from '../components/Review'
import Hero from '../components/Hero-section'


const Home = () => {
  return (
    <div>
      <Hero/>
      <Card/>
      <Review/>
    </div>
  )
}

export default Home
